import React, { memo } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { ProfileInputCell } from '../general/cells/profile-input'
import { User } from '@app/types'

const RemoveDataViewComponent = ({
  onRemoveAllWebsitePress,
  onDeleteAccountPress,
  user,
  loading,
}: {
  user?: User
  loading?: boolean
  onRemoveAllWebsitePress(): Promise<void>
  onDeleteAccountPress(): Promise<void>
}) => {
  const { t } = useTranslation('settings')

  const deleteText = `${t('delete')} ${t('account')}`
  const deleteDataText = `${t('delete')} ${t('data')}`

  const { activeSubscription } = user ?? {}

  return (
    <>
      <ProfileInputCell
        title={deleteDataText}
        subTitle={t('delete-data-details')}
        skeletonLoad={!user && loading}
        disabledWall={!activeSubscription}
        submitLabel={{
          submit: deleteDataText,
          disabled: !activeSubscription,
        }}
        onSubmit={onRemoveAllWebsitePress}
      />

      <ProfileInputCell
        title={deleteText}
        subTitle={t('delete-acc-details')}
        skeletonLoad={!user && loading}
        submitLabel={{
          submit: deleteText,
        }}
        onSubmit={onDeleteAccountPress}
        redBorder
      />
    </>
  )
}

export const RemoveDataView = memo(RemoveDataViewComponent)
